import { Component } from "react";
import { withRouter } from "react-router-dom";
import OrderBox from "../../components/OrderBox";
import TitleBar from "../../components/ui/TitleBar";

import "./style.scss";

class PastOrders extends Component {
    render() {
        let orders = [
            {
                sender: {
                    name: "Ari Kaplan",
                    address: "4206 Spruce Street",
                    address2: "Philadelphia, PA, 19104"
                },
                recipient:{
                    name: "Vidya Plainfield",
                    address: "1040 5th Ave",
                    address2: "New York, NY, 02653"
                },
                count: 4,
                price: 13.00,
                postage: 0.55,
                orderID: "1276930-B",
                sendDate: "November 6, 2020",
                giftCardPrice: 25,
                insert: "Business Card",
                writingStyle: "Proper Jeff",
                letter:`<span className="strong">Dear {{First Name}}</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam egestas a tellus eget malesuada. Pellentesque maximus egestas ornare. Integer sit amet erat tortor. Integer non dolor id massa lacinia porttitor non eget mi. Maecenas faucibus lectus lorem, eu commodo sapien dictum in. Cras semper et dolor vel mollis. Ut tempus, tellus nec vehicula faucibus, tellus libero egestas justo, non tristique orci purus ac dolor. Phasellus mollis risus vel purus viverra ultricies. Fusce interdum blandit biam.</span>`,
                image:"https://via.placeholder.com/146x189/004AAB"
            },
            {
                sender: {
                    name: "Ari Kaplan 2",
                    address: "4206 Spruce Street",
                    address2: "Philadelphia, PA, 19104"
                },
                recipient:{
                    name: "Vidya Plainfield",
                    address: "1040 5th Ave",
                    address2: "New York, NY, 02653"
                },
                count: 4,
                price: 13.00,
                postage: 0.55,
                orderID: "1276930-B",
                sendDate: "November 6, 2020",
                giftCardPrice: 25,
                insert: "Business Card",
                writingStyle: "Proper Jeff",
                letter:`<span className="strong">Dear {{First Name}}</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam egestas a tellus eget malesuada. Pellentesque maximus egestas ornare. Integer sit amet erat tortor. Integer non dolor id massa lacinia porttitor non eget mi. Maecenas faucibus lectus lorem, eu commodo sapien dictum in. Cras semper et dolor vel mollis. Ut tempus, tellus nec vehicula faucibus, tellus libero egestas justo, non tristique orci purus ac dolor. Phasellus mollis risus vel purus viverra ultricies. Fusce interdum blandit biam.</span>`,
                image:"https://via.placeholder.com/146x189/004AAB"
            },
            {
                sender: {
                    name: "Ari Kaplan 3",
                    address: "4206 Spruce Street",
                    address2: "Philadelphia, PA, 19104"
                },
                recipient:{
                    name: "Vidya Plainfield",
                    address: "1040 5th Ave",
                    address2: "New York, NY, 02653"
                },
                count: 4,
                price: 13.00,
                postage: 0.55,
                orderID: "1276930-B",
                sendDate: "November 6, 2020",
                giftCardPrice: 25,
                insert: "Business Card",
                writingStyle: "Proper Jeff",
                letter:`<span className="strong">Dear {{First Name}}</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam egestas a tellus eget malesuada. Pellentesque maximus egestas ornare. Integer sit amet erat tortor. Integer non dolor id massa lacinia porttitor non eget mi. Maecenas faucibus lectus lorem, eu commodo sapien dictum in. Cras semper et dolor vel mollis. Ut tempus, tellus nec vehicula faucibus, tellus libero egestas justo, non tristique orci purus ac dolor. Phasellus mollis risus vel purus viverra ultricies. Fusce interdum blandit biam.</span>`,
                image:"https://via.placeholder.com/146x189/004AAB"
            }
        ];

        return (
            <div className="full-container">
                <section className="section-box past-orders">
                    <TitleBar title="Past Orders" />
                    <OrderBox orders={orders} edit={false} />
                    <OrderBox plain={true} orders={orders} edit={false} />
                </section>
            </div>
        )
    }
}

export default withRouter(PastOrders);